import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Tooltip, Icon } from '@material-ui/core';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

class QuestionGradeIcon extends Component {

    // Given a list of answers, determines if a correct answer is available
    isCorrectAnswerAvailable = (answerList) => {
        return (answerList.filter((answer) => answer.header.Correct).length || 0) > 0;
    }

    getQuestionGradeIcon = (question, studentQuestion) => {
        const student_score        = Number(studentQuestion.Score);
        const max_score            = Number(question.header.Score);
        const is_graded            = studentQuestion.IsGraded;
        const answer_count         = studentQuestion.studentAnswerList.length;
        const is_correct_available = this.isCorrectAnswerAvailable(question.answerList);

        if (!is_graded) {
            return (
                <Tooltip title="Awaiting Instructor Grade">
                    <Icon style={{ color: 'orange' }}>history</Icon>
                </Tooltip>
            );
        }

        if (student_score >= max_score) {
            return (
                <Tooltip title="Correct">
                    <Icon style={{ color: 'green' }}>check</Icon>
                </Tooltip>
            );
        }

        if (student_score > 0 && student_score < max_score) {
            return (
                <Tooltip title="Partially Correct">
                    <Icon style={{ color: 'orange' }}>check</Icon>
                </Tooltip>
            );
        }

        return (
            <Tooltip title="Incorrect">
                <Icon style={{ color: 'red' }}>close</Icon>
            </Tooltip>
        );
    }

    render() {
        const { question, studentQuestion } = this.props

        return this.getQuestionGradeIcon(question, studentQuestion);
    }
}

export default withStyles(null, { withTheme: true })(withRouter(connect(null, null)(QuestionGradeIcon)));






// WEBPACK FOOTER //
// src/main/content/quiz/components/QuestionGradeIcon.js